import React, { useState } from "react";
import { Card, Button, Modal, Select, Space } from "antd";
import { BarChartOutlined } from "@ant-design/icons";
import AttendanceCharts from "../../HrmsDashboard/AttendanceCharts";
import { getMonth, getYear } from "../../../lib/yearMonth";

export default function DashboardCharts({ analyticsReport, trendReport, employees, analyticsMonth, analyticsYear, setAnalyticsMonth, setAnalyticsYear }) {

const [open,setOpen] = useState(false);

const months = getMonth();
const years = getYear();

return(

<>

<Card
title={`Attendance Analytics (${analyticsMonth} ${analyticsYear})`}
      extra={
        <Space>
          <Select
            value={analyticsMonth}
            style={{ width: 140 }}
            options={months.map((m) => ({
              value: m.month,
              label: m.month,
            }))}
            onChange={setAnalyticsMonth}
          />
          <Select
            value={analyticsYear}
            style={{ width: 110 }}
            options={years.map((y) => ({
              value: String(y.year),
              label: String(y.year),
            }))}
            onChange={setAnalyticsYear}
          />
        </Space>
      }
      style={{ borderRadius: 12 }}
    >

{/* View attendance trends and leave breakdown. */}

<AttendanceCharts
analyticsReport={analyticsReport}
trendReport={trendReport}
employees={employees}
/>

</Card>



{/* <Modal
open={open}
onCancel={()=>setOpen(false)}
footer={null}
width={1000}
title="Attendance Analytics"
>

<AttendanceCharts
attendanceReport={attendanceReport}
employees={employees}
/>

</Modal> */}

</>

);

}